import { render } from "./Grade.vue?vue&type=template&id=49e2adc6&scoped=true&ts=true"
import script from "./Grade.vue?vue&type=script&lang=ts"
export * from "./Grade.vue?vue&type=script&lang=ts"

import "./Grade.vue?vue&type=style&index=0&id=49e2adc6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49e2adc6"]])

export default __exports__